/*jshint esversion: 6 */
// import { mapGetters, mapActions } from 'vuex';

import { InfoBoxMixin} from '@/mixins/InfoBox.mixin.js';
import { WaggonInfoMixin } from '@/mixins/WaggonInfo.mixin.js';

export const WorkPackageLargeMixin = {
  components: {
  },
  mixins: [
    InfoBoxMixin,
    WaggonInfoMixin
  ],
  data: () => ({
    show_info_box: false,
    show_info_box_body: '',
    work_packages_large: [],
    work_packages_large_index: 0
  }),
  computed: {
    // ...mapGetters('View', [
    //   'is_show_side_bar'
    // ]),
  },
  methods: {
    clickWaggon(work_packages){
      this.work_packages_large = work_packages;
      this.show_info_box_body = 'info';
      this.work_packages_large_index = 0;
      this.show_info_box = true;
    },
    closeInfoBox(){
      this.show_info_box = false;
    },
    changeWPLarge(index){
      this.work_packages_large_index = index;
    },
    showUp(){
      if (this.show_info_box_body === 'info') {
        return false;
      } else {
        return true;
      }
    },
    showRight(){
      return false;
    },
    showDown(){
      switch (this.show_info_box_body) {
        case 'info':
          return true;
        case 'worksteps':
          return true;
        case 'qualitysteps':
          return true;
        default:
          return false;
      }
    },
    showLeft(){
      return false;
    },
    routeUp(){
      switch (this.show_info_box_body) {
        case 'worksteps':
          this.show_info_box_body = 'info';
          break;
        case 'qualitysteps':
          this.routeToSteps('worksteps');
          break;
        case 'defectsteps':
          this.routeToSteps('qualitysteps');
          break;
        case 'nosteps':
          this.show_info_box_body = 'info';
          break;
      }
    },
    routeRight(){},
    routeDown(){
      switch (this.show_info_box_body) {
        case 'info':
          this.routeToSteps('worksteps');
          break;
        case 'worksteps':
          this.routeToSteps('qualitysteps');
          break;
        case 'qualitysteps':
          this.routeToSteps('defectsteps');
          break;
      }
    },
    routeLeft(){},
    routeToSteps(steps){
      if (steps === 'worksteps') {
        if (this.work_packages_large[this.work_packages_large_index].work_steps.length === 0) {
          this.show_info_box_body = 'nosteps';
          return;
        }
      }
      if (steps === 'qualitysteps') {
        if (this.work_packages_large[this.work_packages_large_index].quality_steps.length === 0) {
          this.show_info_box_body = 'nosteps';
          return;
        }
      }
      if (steps === 'defectsteps') {
        if (this.work_packages_large[this.work_packages_large_index].defect_steps.length === 0) {
          this.show_info_box_body = 'nosteps';
          return;
        }
      }
      this.show_info_box_body = steps;
    }
  }
};
